<template>
  <div id="LiveTestMain" align="center" valign="center">
    <SysEnvTest />
    <NetEnvTest />
    <LiveEnvTest />
    <div class="test-again">
      <el-button type="success" @click="reTest">点击重新检测</el-button>
    </div>
  </div>
</template>

<script>
import NetEnvTest from './NetEnvTest'
import SysEnvTest from './SysEnvTest'
import LiveEnvTest from './LiveEnvTest'
export default {
  name: 'LiveTestMain',
  components: {
    NetEnvTest,
    SysEnvTest,
    LiveEnvTest
  },
  methods: {
    reTest() {
      window.location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .cell {
  display: flex;
  align-items: center;
}
.test-again {
  height: 40px;
  padding: 30px 0 30px;
  text-align: center;
}
</style>
